import React from 'react';
import { motion } from 'framer-motion';
interface PrimaryButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  icon?: React.ReactNode;
}
export function PrimaryButton({
  children,
  onClick,
  disabled = false,
  className = '',
  icon
}: PrimaryButtonProps) {
  return <motion.button whileTap={disabled ? {} : {
    scale: 0.97
  }} onClick={onClick} disabled={disabled} className={`w-full min-h-[56px] rounded-lg font-bold text-lg flex items-center justify-center gap-2 transition-colors ${disabled ? 'bg-slate-800 text-slate-500 cursor-not-allowed' : 'bg-yellow-500 hover:bg-yellow-400 text-slate-950 shadow-lg shadow-yellow-500/20'} ${className}`} data-id="element-1107">
      {icon}
      {children}
    </motion.button>;
}